module.exports = __webpack_public_path__ + "media/images/application2/help-c6d6a401e6b9b7b8a121bb11ad90ef0b.svg";